import { render, staticRenderFns } from "./SpaceActionButton.vue?vue&type=template&id=0e313fa7&scoped=true"
import script from "./SpaceActionButton.vue?vue&type=script&lang=ts"
export * from "./SpaceActionButton.vue?vue&type=script&lang=ts"
import style0 from "./SpaceActionButton.vue?vue&type=style&index=0&id=0e313fa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e313fa7",
  null
  
)

export default component.exports